import { render } from "./AppMain.vue?vue&type=template&id=43b0f31a"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=43b0f31a&lang=css"
script.render = render

export default script